import { Injectable } from '@angular/core';

// Monaco is exposed globally after the editor script loads.
declare const monaco: any;

@Injectable({
    providedIn: 'root',
})
export class MonacoConfigService {
    private isConfigured = false;
    private schemas: any[] = [];

    constructor() { }

    configureMonaco() {
        if (this.isConfigured) {
            return;
        }

        this.waitForMonaco().then(() => {
            monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
                validate: true,
                schemas: this.schemas
            });
            this.isConfigured = true;
        });
    }

    addSchema(schema: any) {
        this.schemas.push(schema);
        this.waitForMonaco().then(() => {
            monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
                validate: true,
                schemas: this.schemas
            });
        });
    }

    private waitForMonaco(): Promise<void> {
        return new Promise((resolve) => {
            const check = () => {
                if (typeof monaco !== 'undefined' && monaco.languages?.json) {
                    resolve();
                } else {
                    setTimeout(check, 50);
                }
            };
            check();
        });
    }
}
